import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useNavigate } from 'react-router-dom';
import Tooltip from 'shared/components/Tooltip';
import styles from './IconBadge.module.scss';

const IconBadge = ({ icon, children, onClick, link, position, tooltipPosition, className }) => {
  const navigate = useNavigate();
  const onBadgeClick = () => {
    if (link !== null) {
      navigate(link);
      return;
    }

    if (onClick !== null) {
      onClick();
    }
  };

  const getIconClasName = () => {
    switch (icon) {
      case 'error':
        return 'las la-exclamation-circle';
      default:
        return 'la la-exclamation-triangle';
    }
  };

  return (
    <span
      className={cn(styles.badge, styles[position], { [styles.clickable]: !(onClick === null && link === null) }, className)}
      onClick={onBadgeClick}
    >
      {children ? <Tooltip content={children} position={tooltipPosition}><i className={getIconClasName()} /></Tooltip> : <i className={getIconClasName()} />}
    </span>
  );
};

IconBadge.propTypes = {
  icon: PropTypes.oneOf(['error', 'warning']),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  link: PropTypes.string,
  onClick: PropTypes.func,
  position: PropTypes.oneOf(['left', 'right']),
  tooltipPosition: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  className: PropTypes.string,
};

IconBadge.defaultProps = {
  icon: 'warning',
  children: null,
  link: null,
  onClick: null,
  position: 'right',
  tooltipPosition: 'top',
  className: null,
};

export default IconBadge;
